import React from "react";
import { PendingApproval } from "../../../containers";

const ManageApproval = (props) => {
  return <PendingApproval {...props} />;
};

export default ManageApproval;
